import personeLogoBlack from '../images/persone-logo-black.png'
import personeLogoWhite from '../images/persone-logo-white.png'


const PersoneIcon = ({ theme }) => {
    
    return (
        <div className='persone-logo-wrapper'>
            {theme === 'dark' ?
                <>
                    <img
                        src={personeLogoWhite}
                        className="persone-logo"
                        alt="Persone"
                        width={20}
                        height={20}
                    // quality={100}
                    />
                    <div className="corner-bottom-left top">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="black"></path>
                        </svg>
                    </div>
                    <div className="corner-bottom-left bottom">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="black"></path>
                        </svg>
                    </div>
                </>
                :
                <>
                    <img
                        src={personeLogoBlack}
                        className="persone-logo"
                        alt="Persone"
                        width={20}
                        height={20}
                    // quality={100}
                    />
                    <div className="corner-bottom-left top">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                        </svg>
                    </div>
                    <div className="corner-bottom-left bottom">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                        </svg>
                    </div>
                </>
            }
        </div>
    )
}

export default PersoneIcon;